import { GlobalResponseObject } from "../../common";
import { LatestNewQuestionModel } from "./latest-new-questions-model";

export class LatestNewQuestionsResponse extends GlobalResponseObject {
    data: LatestNewQuestionModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data: LatestNewQuestionModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}